import React from 'react';
import { func, number, bool } from 'prop-types';
import { ClickAwayListener } from '@nextiva/next-ui-components';
import clsx from 'clsx';

import { SvgActive, SvgInActive } from 'components/SvgIcon';

import MemoCheckbox from './MemoCheckbox';

const TableSettings = ({
  checkBoxStateHelper,
  handleClose,
  handleToggle,
  selectCount,
  userFilterStatus,
}) => {
  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div
        className="m-table-settings"
        data-testid="PlatformAdminUI-UsersLink-TableSettings"
      >
        <div
          className="m-table-settings__header"
          data-testid="PlatformAdminUI-UsersLink-TableSettings-Header"
        >
          <div
            className="m-table-settings__header--text"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-Header-Columns"
          >
            Table Columns
          </div>
          <div
            className="m-table-settings__header--text"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-Header-Count"
          >
            ({selectCount} of 4 selected)
          </div>
          <div
            className="m-table-settings__header--text"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-Header-Status"
          >
            Showing: {userFilterStatus ? 'Active' : 'Inactive'}
          </div>
        </div>
        <div className="m-table-settings__header">
          <div className="m-table-settings__header--item">
            <button
              className={clsx(
                'm-table-settings__button',
                userFilterStatus && 'active',
              )}
              onClick={() => handleToggle(true)}
              type="button"
              data-testid="PlatformAdminUI-UsersLink-TableSettings-ActiveButton"
            >
              <SvgActive />
            </button>
          </div>
          <div className="m-table-settings__header--item">
            <button
              className={clsx(
                'm-table-settings__button',
                !userFilterStatus && 'inactive',
              )}
              onClick={() => handleToggle(false)}
              type="button"
              data-testid="PlatformAdminUI-UsersLink-TableSettings-InActiveButton"
            >
              <SvgInActive />
            </button>
          </div>
        </div>
        <div className="m-table-settings__item">
          <span
            className="m-table-settings__item--label"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-PhoneNumber"
          >
            Phone Number
          </span>
          <div
            className="m-table-settings__item--action"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-PhoneNumber-CheckBox"
          >
            <MemoCheckbox
              id="table-settings-checkbox-0"
              checkBoxStateHelper={checkBoxStateHelper}
              checkBoxValue="Phone Number"
              checkBoxField="phoneNumber"
              fieldType="string"
            />
          </div>
        </div>
        <div className="m-table-settings__item">
          <span
            className="m-table-settings__item--label"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-Extension"
          >
            Extension
          </span>
          <div
            className="m-table-settings__item--action"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-Extension-CheckBox"
          >
            <MemoCheckbox
              id="table-settings-checkbox-1"
              checkBoxStateHelper={checkBoxStateHelper}
              checkBoxValue="Extension"
              checkBoxField="extension"
              fieldType="string"
            />
          </div>
        </div>
        <div className="m-table-settings__item">
          <span
            className="m-table-settings__item--label"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-Team"
          >
            Team
          </span>
          <div
            className="m-table-settings__item--action"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-Team-CheckBox"
          >
            <MemoCheckbox
              id="table-settings-checkbox-2"
              checkBoxStateHelper={checkBoxStateHelper}
              checkBoxValue="Team"
              checkBoxField="teamDisplay"
              fieldType="string"
            />
          </div>
        </div>
        <div className="m-table-settings__item">
          <span
            className="m-table-settings__item--label"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-Role"
          >
            Role
          </span>
          <div
            className="m-table-settings__item--action"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-RoleCheckBox"
          >
            <MemoCheckbox
              id="table-settings-checkbox-3"
              checkBoxStateHelper={checkBoxStateHelper}
              checkBoxValue="Role"
              checkBoxField="roleDisplay"
              fieldType="string"
            />
          </div>
        </div>
        <div className="m-table-settings__item">
          <span
            className="m-table-settings__item--label"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-Status"
          >
            Status
          </span>
          <div
            className="m-table-settings__item--action"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-StatusCheckBox"
          >
            <MemoCheckbox
              id="table-settings-checkbox-4"
              checkBoxStateHelper={checkBoxStateHelper}
              checkBoxValue="Status"
              checkBoxField="statusDisplay"
              fieldType="string"
            />
          </div>
        </div>
        <div className="m-table-settings__item">
          <span
            className="m-table-settings__item--label"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-CreatedDate"
          >
            Created date
          </span>
          <div
            className="m-table-settings__item--action"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-CreatedDateCheckBox"
          >
            <MemoCheckbox
              id="table-settings-checkbox-5"
              checkBoxStateHelper={checkBoxStateHelper}
              checkBoxValue="Created Date"
              checkBoxField="createdDate"
              fieldType="date"
            />
          </div>
        </div>
        <div className="m-table-settings__item">
          <span
            className="m-table-settings__item--label"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-DeactivatedDate"
          >
            Deactivated date
          </span>
          <div
            className="m-table-settings__item--action"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-DeactivatedDateCheckBox"
          >
            <MemoCheckbox
              id="table-settings-checkbox-6"
              checkBoxStateHelper={checkBoxStateHelper}
              checkBoxValue="Deactivated date"
              checkBoxField="deactivatedDate"
              fieldType="date"
            />
          </div>
        </div>
        <div className="m-table-settings__item">
          <span
            className="m-table-settings__item--label"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-UpdatedDate"
          >
            Updated date
          </span>
          <div
            className="m-table-settings__item--action"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-UpdatedDateCheckBox"
          >
            <MemoCheckbox
              id="table-settings-checkbox-7"
              checkBoxStateHelper={checkBoxStateHelper}
              checkBoxValue="Updated date"
              checkBoxField="updatedDate"
              fieldType="date"
            />
          </div>
        </div>
        <div className="m-table-settings__item">
          <span
            className="m-table-settings__item--label"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-Location"
          >
            Location
          </span>
          <div
            className="m-table-settings__item--action"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-LocationCheckBox"
          >
            <MemoCheckbox
              id="table-settings-checkbox-8"
              checkBoxStateHelper={checkBoxStateHelper}
              checkBoxValue="Location"
              checkBoxField="locationDisplay"
              fieldType="string"
            />
          </div>
        </div>
        <div className="m-table-settings__item">
          <span
            className="m-table-settings__item--label"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-TimeZone"
          >
            Time Zone
          </span>
          <div
            className="m-table-settings__item--action"
            data-testid="PlatformAdminUI-UsersLink-TableSettings-TimeZoneCheckBox"
          >
            <MemoCheckbox
              id="table-settings-checkbox-9"
              checkBoxStateHelper={checkBoxStateHelper}
              checkBoxValue="Time Zone"
              checkBoxField="timeZone"
              fieldType="string"
            />
          </div>
        </div>
      </div>
    </ClickAwayListener>
  );
};

TableSettings.propTypes = {
  checkBoxStateHelper: func.isRequired,
  handleClose: func.isRequired,
  handleToggle: func.isRequired,
  selectCount: number.isRequired,
  userFilterStatus: bool,
};

TableSettings.defaultProps = {
  userFilterStatus: false,
};

export default TableSettings;
